<script setup lang="ts">
  import { ref } from "vue";
  import { Video } from "lucide-vue-next";
  import { Tooltip } from "@/components/ui/tooltip";
  import type { DimensionImage } from "../pivotDimensions";

  withDefaults(defineProps<{ image: DimensionImage; label: string; size?: "sm" | "md" }>(), { size: "md" });

  // An upload whose URL no longer resolves falls back to its name.
  const failed = ref(false);
</script>

<template>
  <Tooltip
    :content="label"
    side="top">
    <span
      class="inline-flex items-center justify-center shrink-0 rounded bg-muted/60 overflow-hidden"
      :class="size === 'sm' ? 'size-5' : 'size-8'">
      <Video
        v-if="image.mediaType === 'video' || failed"
        class="text-muted-foreground"
        :class="size === 'sm' ? 'size-3' : 'size-4'" />
      <img
        v-else
        :src="image.url"
        :alt="label"
        loading="lazy"
        class="size-full object-cover"
        @error="failed = true" />
    </span>
  </Tooltip>
</template>
